export default __webpack_public_path__ + "static/media/formato-de-inscripcion-o-movimientos-posteriores-al-padron-estatal.c1bdc3ec.pdf";